import { List, Record } from 'immutable';
import { ADD_FLAG, REMOVE_FLAG } from '../actions/Flags';
// exported for testing
export const makeFlagsState = Record({
  flags: List()
});
export default function FlagsReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : makeFlagsState();
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ADD_FLAG:
      {
        const {
          flag
        } = action;
        // New flags must be added to the beginning to be animated correctly
        return state.update('flags', flags => {
          const index = flags.findIndex(f => f.key === flag.key);
          return index === -1 ? flags.unshift(flag) : flags.set(index, flag);
        });
      }
    case REMOVE_FLAG:
      {
        const {
          key
        } = action;
        return state.update('flags', flags => flags.filterNot(f => f.key === key));
      }
    default:
      // Flow compile-time validation that we've handled every action
      // prettier-ignore
      action;
      return state;
  }
}